__turbopack_context__.v({
  "container": "FourColumnScroll-module-scss-module__63mmfq__container",
  "flexItem": "FourColumnScroll-module-scss-module__63mmfq__flexItem",
  "flexWrapper": "FourColumnScroll-module-scss-module__63mmfq__flexWrapper",
  "gridItem": "FourColumnScroll-module-scss-module__63mmfq__gridItem",
  "gridWrapper": "FourColumnScroll-module-scss-module__63mmfq__gridWrapper",
  "section": "FourColumnScroll-module-scss-module__63mmfq__section",
});
